import axios from 'axios';
import getDetails from '../api/EnviromentConfig';
let salesUrl: string = getDetails().apiurl;
let subscriptionKey: string = getDetails().subscriptionKey;

export async function getSalesData(
  partnerId: string | null,
  startDate: string,
  endDate: string,
  brandId: string,
  businessModelId: string,
  channel?: string,
  categoryId?: string
) {
  try {
    const response = await axios({
      method: 'GET',
      url:
        salesUrl +
        'Sales/GetSalesData?partnerID=' +
        partnerId +
        '&startDate=' +
        startDate +
        '&endDate=' +
        endDate +
        '&businessModelId=' +
        businessModelId +
        '&channel=' +
        channel +
        '&categoryId=' +
        categoryId +
        '&brandId=' +
        brandId,
      headers: { 'Ocp-Apim-Subscription-Key': subscriptionKey },
    });
    return response;
  } catch {
    return null;
  }
}

export async function getSalesExcel(
  partnerId: string | null,
  startDate: string,
  endDate: string,
  brandId: string,
  businessModelId: string,
  channel?: string,
  categoryId?: string
) {
  try {
    const response = await axios({
      method: 'GET',
      url:
        salesUrl +
        'Sales/GetSalesExcel?partnerID=' +
        partnerId +
        '&startDate=' +
        startDate +
        '&endDate=' +
        endDate +
        '&businessModelId=' +
        businessModelId +
        '&channel=' +
        channel +
        '&categoryId=' +
        categoryId +
        '&brandId=' +
        brandId,
      headers: { 'Ocp-Apim-Subscription-Key': subscriptionKey },
      responseType: 'blob',
    });
    return response.data;
  } catch {
    return null;
  }
}